import { arrayMove } from "@dnd-kit/sortable";
import { useMemo, useReducer } from "react";
import { useTranslation } from "react-i18next";
import { Game } from "../../Games";
import { SortGame, SortGameActions } from "./SortGame";
import { SortableItem } from "./components/Sortable";

export const useSortGameReducer = ({
  current,
}: {
  current: Game | undefined;
}) => {
  const { t } = useTranslation();

  const [data, dispatch] = useReducer(
    (data: SortGame, action: SortGameActions) => {
      switch (action.type) {
        case "switch":
          const oldIndex = data.sortables.indexOf(action.activeId);
          const newIndex = data.sortables.indexOf(action.overId);
          const newSortables = arrayMove(data.sortables, oldIndex, newIndex);

          const itemValid = newSortables.reduce((acc, sortable, i) => {
            if (sortable === (current as SortGame).sortables[i]) acc += 1;
            return acc;
          }, 0);

          return {
            ...data,
            progress: itemValid / data.sortables.length,
            isValid: itemValid === data.sortables.length,
            sortables: newSortables,
          };
        default:
          return { ...data };
      }
    },
    {
      ...current,
      isValid: false,
      progress: 0,
      sortables: [...(current as SortGame).sortables].sort(
        (a, b) => Math.random() - 0.5
      ),
    } as SortGame
  );

  const sortables = useMemo(
    () =>
      data.sortables.map((id) => (
        <SortableItem key={id} id={id} disable={data.isValid ?? false}>
          {t(`games.${data.id}.${id}`)}
        </SortableItem>
      )),

    [t, data.id, data.sortables, data.isValid]
  );

  return { sortables, dispatch, items: data.sortables, data };
};
